var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getCurrentRelatedProducts.length)?_c('m-product-carousel',{attrs:{"products":_vm.getCurrentRelatedProducts}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }